<div class="agu-sort">
    <button
        type="button"
        class="agu-sort__trigger"
        aria-haspopup="listbox"
        [attr.aria-expanded]="Open"
        (click)="Toggle()"
    >
        <span class="agu-sort__glyph" aria-hidden="true">↕</span>
        <!-- `agu-sort__value` carries no rule of its own (it inherits the
             trigger's type): it is kept deliberately as the regression suite's
             probe hook for the control's current value — P-G5 reads
             `.agu-sort__value` (review M-3). -->
        <span class="agu-sort__value">{{ TriggerText }}</span>
    </button>

    @if (Open) {
        <div class="agu-sort__menu" role="listbox" [attr.aria-label]="MenuLabel">
            @for (option of Options; track option.Key) {
                <button
                    type="button"
                    class="agu-sort__option"
                    role="option"
                    [class.agu-sort__option--on]="IsSelected(option)"
                    [attr.aria-selected]="IsSelected(option)"
                    (click)="Pick(option.Key)"
                >
                    {{ option.Label }}
                </button>
            }
        </div>
    }
</div>
